module.exports = __webpack_public_path__ + "img/clinicimg2.569d42c2.jpg";